import Const from '../Const'
import {observable,action,computed} from 'mobx'

class AppState {
  @observable defaultValue = Const.defaultValue
  @observable executeState = Const.executeKey.not
  @observable executeErrorInfo
  @observable playQQMusicWindow = null
  @observable playQQMusicOtherWindow = null
  @observable playQQMusicMvWindow = null
  @observable asyncEffect = null
  @observable inputValueList = {list: [], count: 0}
  @action changeExecuteState=(state)=>{
    if(this.executeState === state)
    {
      return
    }
    this.executeState = state
  }
  @action changeExecuteErrorInfo= (info)=>{
    if(info)
      this.executeErrorInfo = info
  }
  @action setPlayQQMusicWindow = (value)=>{
    this.playQQMusicWindow = value
  }
  @action setPlayQQMusicOtherWindow = (value)=>{
    this.playQQMusicOtherWindow = value
  }
  @action setPlayQQMusicMvWindow = (value)=>{
    this.playQQMusicMvWindow = value
  }
  @action setAsyncEffect = (value)=>{
    this.asyncEffect = value
  }
  @computed get inputValueListValue(){
    return (this.inputValueList.list.length - this.inputValueList.count) <= 0 &&
     (this.inputValueList.list.length - this.inputValueList.count) >= this.inputValueList.list.length
     ? "" : this.inputValueList.list[this.inputValueList.list.length - this.inputValueList.count]
  }
  @action setIuputValueCount = (isUp)=>{
    if(isUp)
      this.inputValueList.count++
    else
      this.inputValueList.count--
    if(this.inputValueList.count >= this.inputValueList.list.length){
      this.inputValueList.count = this.inputValueList.list.length-1
      if(this.inputValueList.count === 0)
        this.inputValueList.count = 1
    }
    else if(this.inputValueList.count < 0)
      this.inputValueList.count = 0
    console.log(this.inputValueList.count)
  }
  @action setInputValueCountZero = ()=>{
    this.inputValueList.count = 0
  }
  @action setInputValueList = (list)=>{
    this.inputValueList.list = list
  }
  @action pushInputValueList = (value)=>{
    this.inputValueList.list.push(value)
    while(this.inputValueList.list.length > Const.count.storageInputValueCount)
    {
      this.inputValueList.list.shift()
    }
  }
}
export const appState = new AppState()



// WEBPACK FOOTER //
// ./src/stateClass/AppState.js